<template>
  <div style="margin-bottom: 48px;">
    <search-bar
      @search="searchPurcsale"
      name=""
      placeholder="输入产品编号、名称、型号、工单号进行查找"
      ref="searchBar"
    />
    <year-month-filter-bar @change="searchPurcsale" ref="yearMonthFilterBar"/>
    <div class="weui-cells">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="(item, index) in list2"
        :key="index"
        :to="{name: 'OutProductionMakeinReportDetail', params: { item }}"
      >
        <div class="weui-cell__bd">
          <p>{{item.ma_code}}</p>
          <p class="list-item-muted">{{item.pr_code}} {{item.pr_detail}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'yyyy-MM-dd'">{{item.ma_planbegindate}}</p>
          <p class="list-item-muted">{{item.ma_wcname}}</p>
        </div>
      </router-link>
    </div>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{list2.length}}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import YearMonthFilterBar from "@/components/YearMonthFilterBar.vue";

export default {
  components: {
    SearchBar,
    YearMonthFilterBar
  },
  data() {
    return {
      list2: []
    }
  },
  mounted() {
    this.searchPurcsale()
  },
  methods: {
    searchPurcsale() {
      let me = this

      let yearMonthFilterBar = me.$refs.yearMonthFilterBar
      let yearmonth = yearMonthFilterBar.yearmonth

      let searchBar = me.$refs.searchBar
      let keyword = searchBar.keyword

      let params = {
        number: 1,
        size: 99999,
        mode: 'DETAIL',
        condition: [
          {"type":"condition","value":` (DATE_FORMAT(ma_planenddate,'%Y%m') = ${yearmonth})`}
        ],
        page: 1,
        start: 0,
        limit: 99999,
        // filter: [{"type":"string","operation":"c","operationText":"包含","label":"部门","field":"department.dp_name","value":"总"}]
      }
      if(keyword) {
        params.condition.push(
          {"type":"condition","value":`(upper(pr_orispeccode) like '%${keyword}%' or upper(pr_code) like '%${keyword}%' or upper(pr_detail) like '%${keyword}%' or upper(ma_code) like '%${keyword}%')`},
        )
      }
      params.condition = JSON.stringify(params.condition)

      me.$ajax({
        url: "/api/make/report/makein",
        params,
      }).then(function (res) {
        if (res.success) {
          me.list2 = res.data.list.list
        }
      });
    }
  }
}
</script>